import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome'
import { useLocalSearchParams, useRouter } from 'expo-router'
import React, { useState } from 'react'
import { ms, ScaledSheet } from 'react-native-size-matters'
import { FormButton } from '~components/FormButton'
import ModalScreen, { getModalStyleDefinition, ModalFooter } from '~components/ModalScreen'
import { Text, View } from '~components/Themed'
import { ValidationError } from '~errors/ValidationError'
import { useTheme } from '~theme/ThemeManager'
import { useAxios } from '~utils/fetch'

export default function ReportCommunityChatScreen(): React.JSX.Element {
  const { theme } = useTheme()
  const styles = useStyles()
  const [reported, setReported] = useState(false)
  const { templateId } = useLocalSearchParams<{ templateId: string }>()
  const router = useRouter()

  const [{ loading, error }, execute] = useAxios(
    {
      url: `/api/v1/chats/${templateId}/reports`,
      method: 'POST',
    },
    { manual: true },
  )

  const report = async () => {
    if (reported) {
      router.canGoBack() && router.back()
      return
    }

    try {
      const result = await execute()

      if (result.status === 200) {
        setReported(true)
      }
    } catch (error) {
      console.info(error)
    }
  }

  return (
    <ModalScreen
      Footer={
        <ModalFooter>
          <View></View>
          <FormButton onPress={report} title={reported ? 'Close' : 'Report'} disabled={loading} />
          <View></View>
        </ModalFooter>
      }
    >
      <View style={styles.inner}>
        <View style={[styles.content, styles.contentCenter]}>
          <FontAwesomeIcon
            icon={['fal', reported ? 'shield-check' : 'flag']}
            size={ms(53)}
            color={theme.primary}
            style={styles.button}
          />

          <View style={styles.titleContainer}>
            <Text style={styles.title}>{reported ? 'Chat Reported' : 'Report Chat'}</Text>
            <Text style={styles.subtitle}>
              {reported
                ? 'Thank you for reporting the chat - the Chatta Team will check the content shortly'
                : 'Report this chat for inappropriate content?'}
            </Text>
          </View>

          {error && (
            <Text style={styles.error}>
              {error instanceof ValidationError ? error.message : 'An error occurred'}
            </Text>
          )}
        </View>
      </View>
    </ModalScreen>
  )
}

const useStyles = () => {
  const { theme, mode } = useTheme()
  return ScaledSheet.create({
    ...getModalStyleDefinition(theme, mode),
    button: {
      alignSelf: 'center',
    },
    contentCenter: {
      justifyContent: 'center',
    },
  })
}
